import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import SelectField from "../Masters/SelectField";
import TableSelectField from "./TableSelectField";

export const monthlist = [
  { id: 1, month: "Jan" },
  { id: 2, month: "Feb" },
  { id: 3, month: "Mar" },
  { id: 4, month: "Apr" },
  { id: 5, month: "May" },
  { id: 6, month: "Jun" },
  { id: 7, month: "Jul" },
  { id: 8, month: "Aug" },
  { id: 9, month: "Sep" },
  { id: 10, month: "Oct" },
  { id: 11, month: "Nov" },
  { id: 12, month: "Dec" },
];

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
const startYear = currentYear - 5; // 5 years ago from the current year
const years = Array.from({ length: 6 }, (_, i) => startYear + i); // 6 years range (from 5 years ago to the current year)

const MonthYearPicker = ({
  name,
  title,
  errors,
  setErrors,
  formData,
  setFormData,
  defaultMonth = currentMonth,
  defaultYear = currentYear,
  width,
  gap,
}) => {
  const [filteredYears, setFilteredYears] = useState(years);
  const [disableValue, setDisableValue] = useState("");

  // Get filtered months based on selected year
  const filteredMonths = useMemo(() => {
    const selectedYear = formData?.consumptionPeriod?.year;
    // If current year is selected, only show months up to current month
    if (selectedYear === currentYear || selectedYear === String(currentYear)) {
      return monthlist.filter((month) => month.id <= currentMonth + 1);
    }
    // For past years, show all months
    return monthlist;
  }, [formData?.consumptionPeriod?.year]);

  // useEffect(() => {
  //   setFormData({
  //     ...formData,
  //     consumptionPeriod: {
  //       ...formData.consumptionPeriod,
  //       month: defaultMonth,
  //       year:defaultYear // Update the 'year' field within 'consumptionPeriod'
  //     },
  //   });
  // }, [defaultMonth, defaultYear]);

  // Handle Month and Year Change
  const handleMonthChange = (event) => {
    setDisableValue("");
    setErrors && setErrors({ ...errors, month: "" });
    const selectedMonthIndex = Number(event.target.value);
    console.log("month", monthlist[selectedMonthIndex - 1], selectedMonthIndex);
    setFormData({
      ...formData,
      consumptionPeriod: {
        ...formData.consumptionPeriod,
        month: selectedMonthIndex, // Update the 'month' field within 'consumptionPeriod'
      },
    });
    // Set the month index - if future month is selected, disable current year
    if (selectedMonthIndex > currentMonth + 1) {
      setDisableValue(currentYear);
      const selectedYear = Number(formData?.consumptionPeriod?.year);
      if (selectedYear === currentYear) {
        setFormData({
          ...formData,
          consumptionPeriod: {
            ...formData.consumptionPeriod,
            year: "", // Clear year if invalid month selected for current year
          },
        });
      }
    }
  };

  const handleYearChange = (event) => {
    setDisableValue("");
    setErrors && setErrors({ ...errors, year: "" });
    const selectedYear = event.target.value;
    const selectedYearNum = Number(selectedYear);
    
    // If current year is selected, validate the month
    if (selectedYearNum === currentYear) {
      const selectedMonth = formData?.consumptionPeriod?.month;
      const selectedMonthNum = Number(selectedMonth);
      // If selected month is invalid (future month), clear it
      if (selectedMonth && selectedMonthNum > currentMonth + 1) {
        setFormData({
          ...formData,
          consumptionPeriod: {
            ...formData.consumptionPeriod,
            year: selectedYear,
            month: "", // Clear invalid month
          },
        });
      } else {
        setFormData({
          ...formData,
          consumptionPeriod: {
            ...formData.consumptionPeriod,
            year: selectedYear,
          },
        });
      }
    } else {
      // For past years, allow any month
      setFormData({
        ...formData,
        consumptionPeriod: {
          ...formData.consumptionPeriod,
          year: selectedYear,
        },
      });
    }
  };

  return (
    <Box>
      {title && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginBottom:
              title === "Consumption Month" ||
              title === "Purchased Month" ||
              title === "Waste Management Month"
                ? 0
                : "-0.5rem",
          }}
        >
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: gap || 1 }}>
        <Box sx={{ minWidth: "48%" }}>
          <SelectField
            name={name}
            value={formData?.consumptionPeriod?.month}
            handleChange={handleMonthChange}
            label="Month"
            field="month"
            errors={errors?.["month"] || ""}
            defaultValue={"Month"}
            options={filteredMonths} // Filtered month options based on selected year
          />
        </Box>

        {/* Year Input */}
        <Box sx={{ minWidth: "48%" }}>
          <SelectField
            name={name}
            value={formData?.consumptionPeriod?.year}
            handleChange={handleYearChange}
            options={filteredYears}
            errors={errors?.["year"] || ""}
            defaultValue={"Year"}
            menuDisable={disableValue}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MonthYearPicker;
